export default __webpack_public_path__ + "static/media/bcci.65881802.png";